import { Directive, ElementRef, Input } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[appInputTrim]'
})
export class InputTrimDirective {
  @Input() trimType  : 'trim-left' | 'alphanumeric' | 'numeric';
  sub$ : Subscription;
  constructor(private el : ElementRef) {
    this.sub$ = fromEvent(this.el.nativeElement, 'input').subscribe(r => {
      let val : string = this.el.nativeElement.value;
      let newVal : string = val;
      if (this.trimType == 'trim-left') {
        newVal = val.trimStart();
      }
      else if (this.trimType == 'alphanumeric') {
        newVal = Array.from(newVal).filter(letter => {
          if (letter >= 'a' && letter <= 'z')
            return true;
          if (letter >= 'A' && letter <= 'Z')
            return true;
          if (letter >= '0' && letter <= '9')
            return true;
        }).join('');
      }
      else if (this.trimType == 'numeric') {
        newVal = Array.from(newVal).filter(letter => letter >= '0' && letter <= '9').join('');
      }
      
      if (newVal != val) {
        this.el.nativeElement.value = newVal;
        this.el.nativeElement.dispatchEvent(new Event('input', {bubbles:true}));
      }
    });
  }

  ngOnDestroy() {
    this.sub$.unsubscribe();
  }

}
